export class MathHelper {
  static coerceValue(value: number, minValue: number, maxValue: number, defaultValue?: number) {
    if (!isNaN(value) && typeof value != "string" && typeof value != "undefined") {
      value = value < minValue ? minValue : value > maxValue ? maxValue : value;
    } else {
      value = defaultValue != undefined ? defaultValue : Number.MIN_VALUE;
    }

    return value;
  }

  static getRandomInteger(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

  static getRandomFloat(min: number, max: number, decimals: number): number {
    const str = (Math.random() * (max - min) + min).toFixed(decimals);

    return parseFloat(str);
  }

  static normalizeAngle(angle: number): number {
    return ((angle % 360) + 360) % 360; //ensure range of 0-359
  }
}
